var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticStyle:{"display":"inline-flex"}},[_vm._t("default",null,{"open":_vm.openPACS,"loading":_vm.loading}),_c('PDFDialog',{ref:"pdfDialog",attrs:{"title":"Imagens em PDF"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }